import React from "react";
import I18n from "lib/i18n";
import PropTypes from "prop-types";

const RoleMenuEntries = ({ role }) => {
  if (role === "Editor" || role === "Author") {
    return (
      <React.Fragment>
        <li className="metrics">
          <a href="https://analytics.theconversation.com/">{I18n.t("top_bar.label.analytics")}</a>
        </li>
      </React.Fragment>
    );
  }

  // There are never any special menu entries for Readers at the moment
  return null;
};

RoleMenuEntries.propTypes = {
  role: PropTypes.string.isRequired,
};

export default RoleMenuEntries;
